import { apiClient } from './';

export const getRemoteConfig = async () => {
  return apiClient.get<any>('/admin/v1/remote-config');
};

export const updateRemoteConfig = async (data: any) => {
  return apiClient.put<any>('/admin/v1/remote-config', data);
};

// SQS 메시지 관리 API
export const getSqsMessageStatus = async (messageId?: string) => {
  const params = messageId ? { messageId } : {};
  return apiClient.get<{
    processingCount?: number;
    processedCount?: number;
    processingMessages?: Array<{
      messageId: string;
      messageContent?: any;
      processingAt?: string;
    }>;
    processedMessages?: Array<{
      messageId: string;
      messageContent?: any;
      processedAt?: string;
    }>;
    processing?: boolean;
    processed?: boolean;
    processingAt?: string;
    processedAt?: string;
    messageContent?: any;
  }>('/admin/v1/sqs-message-status', { params });
};

export const clearStuckSqsMessages = async () => {
  return apiClient.post<{ result: string; message: string }>('/admin/v1/clear-stuck-sqs-messages');
};

export const forceReprocessSqsMessage = async (messageId: string) => {
  return apiClient.post<{ result: string; message: string }>('/admin/v1/force-reprocess-sqs-message', {
    messageId,
  });
};

export const reprocessSqsMessageFromRedis = async (messageId: string) => {
  return apiClient.post<{ result: string; message: string }>('/admin/v1/reprocess-sqs-message-from-redis', {
    messageId,
  });
};

export const uploadExcelForContactExtraction = async (formData: FormData) => {
  return apiClient.post<Blob>('/admin/v1/utility/extract-contacts', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    responseType: 'blob',
  });
};
